import {
    createContext,
    ReactNode,
    useContext,
    useEffect,
    useState,
} from "react";
import { useLocation } from "react-router-dom";

interface GraphEnlargeContextType {
    graphIdToEnlarge: null | string;
    setGraphIdToEnlarge: (graphId: string | null) => void;
}

const GraphEnlargeContext = createContext<GraphEnlargeContextType | undefined>(
    undefined
);

interface GraphEnlargeProviderProps {
    children: ReactNode;
}

export const GraphEnlargeProvider = ({
    children,
}: GraphEnlargeProviderProps) => {
    const [graphIdToEnlarge, setGraphIdToEnlarge] = useState<null | string>(
        null
    );
    const location = useLocation();

    useEffect(() => {
        setGraphIdToEnlarge(null);
    }, [location.pathname]);

    return (
        <GraphEnlargeContext.Provider
            value={{
                graphIdToEnlarge,
                setGraphIdToEnlarge,
            }}
        >
            {children}
        </GraphEnlargeContext.Provider>
    );
};

export const useGraphEnlarge = () => {
    const context = useContext(GraphEnlargeContext);
    if (context === undefined) {
        throw new Error(
            "useGraphEnlarge must be used within a GraphEnlargeProvider"
        );
    }
    return context;
};
